import styled, { css } from "styled-components";

interface Props {
  $isSmall?: boolean;
}

export const Icon = styled.div`
  ${({ $isSmall }: Props) => $isSmall
    ? css`
          width: 60px;
          height: 60px;
        `
    : css`
          width: 80px;
          height: 80px;
        `}
  display: flex;
  align-items: center;
  flex-shrink: 0;
  img {
    width: 100%;
    height: auto;
  }
  @media screen and (max-width: 767px) {
    width: 50px;
    height: 50px;
  }
`;

export const MainTitle = styled.p`
  font-size: ${({ $isSmall }: Props) => ($isSmall ? '18px' : '30px')};
  font-weight: 600;
  line-height: 26px;
  padding: ${({ $isSmall }) => ($isSmall ? '0 16px' : '0 50px')};
  margin-bottom: 0;
  @media screen and (max-width: 767px) {
    font-size: ${({ $isSmall }) => ($isSmall ? '16px' : '18px')};
    padding: ${({ $isSmall }) => ($isSmall ? '0 15px' : '0 30px')};
    line-height: 20px;
  }
  @media screen and (max-width: 499px) {
    padding: 0 15px;
    width: 45%;
  }
`;
